<template>
  <div class="used-coupons">
    <div class="coupon-wrapper" v-show="usedCoupons.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <coupon-list :list="usedCoupons" />
      </list>
    </div>
    <no-data v-show="noData" />
  </div>
</template>

<script>
// 可使用卡券
import { List } from 'vant'
import CouponList from './CouponList'
import NoData from './NoData'
let flag = false
export default {
  name: 'used-coupon',
  components: {
    List,
    CouponList,
    NoData
  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      usedCoupons: [],
      noData: false
    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.getUsedCoupons()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getUsedCoupons(++this.pageNum).then(() => {
          setTimeout(() => {
            flag = false
            this.loading = false
          }, 500)
        }, 300)
      })
    },

    /**
     * 获取已使用卡券
     */
    async getUsedCoupons (pageNum) {
      const res = await this.$axios.get(`api/coupon/used/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          const list = data.data.map(v => {
            v.couponStatus = 1
            return v
          })
          this.usedCoupons = [...this.usedCoupons, ...list]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1 || !pageNum) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
